import { ActiveGroupFilter, SellNowTransactionStatus } from '../enums';
import { PaginationFilters } from './filters-response';

export interface IPagination {
    total?: number;
    limit?: number;
    page?: number;
    pages?: number;
    offset?: number;
    search?: string;
    filter?: Filter;
}

export interface IPaginateResult<T> extends IPagination {
    docs: Array<T>;
    availableFilters?: PaginationFilters;
}

export interface Filter {
    categories?: string[];
    brand?: string;
    condition?: string;
    queryString?: string[];
}

export interface ILlpPagination extends IPagination {
    isHistory: boolean;
}

export interface SellNowStatusPagination extends IPagination {
    status: SellNowTransactionStatus;
    groupStatus?: ActiveGroupFilter;
}
